export enum UserRole {
  USER_ADMIN = "USER_ADMIN",
  EXPERT = "EXPERT",
}

export interface User {
  id: number;
  authUserId: number;
  firstName: string;
  lastName: string;
  email: string;
  dateCreated: Date;
  dateLastLoginLinkSent: Date;
  role: UserRole;
  enabled: boolean;
}
